import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsDO: CultureInfo = {
  name: 'es-DO',
  displayName: 'Spanish (Dominican Republic)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-DO',
  parent: CultureInfoEs
};
